var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"infobox"},[_c('div',{staticClass:"image"},[_vm._t("image")],2),_c('div',{staticClass:"text-content"},[_c('div',{staticClass:"title"},[_vm._t("title")],2),_c('div',{staticClass:"text-body"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }